const atlassianDomains: string[] = [
	'.atlassian.com',
	'.atlassian.net',
	'.jira-dev.com',
	'.jira.com',
	'.atlassian-stg-fedm.net',
	'.atlassian-us-gov-mod.net',
	'.atlassian-us-gov-mod.com',
];

export const isCustomDomain = (hostname: string): boolean =>
	!atlassianDomains.some((domain) => hostname.endsWith(domain));
